import './components/ga-events';            //should be on top of each page's JS file
import "./components/swipe-for-more";       // should be as soon as possible
import "./parts/navigation";
import "./parts/keyboard-navigation";
import "./parts/accept-cookies";
import "./parts/ftc-disclosure";
import "./components/accessibility-widget";
import tooltips from './components/tooltips';
import { shouldInitCarousel } from './components/carousel-viewport';
import './widgets/read-more';
import './components/js-links';
import "./components/svg";

import $ from 'cash-dom';

$(function () {
    tooltips.initOnce();

    const postsCarousel = document.querySelector('#posts_carousel.carousel');

    if (shouldInitCarousel(postsCarousel)) {
        import('./components/Carousel').then(({ default: Carousel }) => {
            Carousel.initAll('#posts_carousel.carousel');
        });
    }
});
